
export enum ProductType {
    REGULAR, // null typeid will default to zero
    NUMBER_OF_TV,
    ADDITIONAL_DVR,
    EMAIL_ADDRESSES,
    AVAST_ANTIVIRUS_EMAIL,
    PHONE_NUMBER,
    BATTERY_BACKUP,
    CHECKBOX,
    PHONE_NUMBER_PUBLISHING,
    CLOUD_BACKUP_EMAIL,
    CLOUD_BACKUP_DISCOUNT,
    CLOUD_BACKUP_AMOUNT,
    CHECKBOX_WITH_EMAIL,
    STATIC_IP_ADDRESSES,
    BUSINESS_TV,
    PREMIUM_PACKAGES,
    STREAMING_DEVICES
}

export enum FieldName {
    ADDITIONAL_DVR = 'additionalDvr',
    NUMBER_OF_TV = 'numberOfTv',
    EMAIL_ADDRESSES = 'emailAddresses',
    AVAST_ANTIVIRUS_EMAIL = 'avastAntivirusEmail',
    PHONE_NUMBER_OPTION = 'phoneNumberOption',
    DIRECTORY_NAME = 'directoryName',
    DIRECTORY_IN_ADDRESS= 'directoryInAddress',
    CLOUD_BACKUP_EMAIL = 'cloudBackUpEmail',
    VOICEMAIL_PLUS_EMAIL = 'voicemailPlusEmail',
    NUMBER_OF_STATIC_IP_ADDRESS = 'staticIpAddress',
    FIRE_OCCUPANCY_TIER = 'fireOccupancyTier',
}

export enum ServiceTypeId {
    Internet = '1',
    TV = '2',
    Telephone = '3',
    Streaming = '4',
    Backup = '5',
    Cloud = '6',
    Watch = '7',
    Protect = '8'
}

export enum AddressDirectoryShowOmit {
    SHOW = 'show',
    OMIT = 'omit'
}

export enum ServiceForOptions {
    RESIDENTIAL = 'Residential',
    BUSINESS = 'Business'
}

export enum InstallationOption {
    CALL_SCHEDULE = 'callScheduled',
    CALL_NOW = 'callNow',
    CHAT = 'chat'
}

export interface JsonData {
    field: FieldName;
    value: any;
}

export interface CatItemBeingProcessed {
    [key: string]: any;
}

export interface CartError {
    requiredFields: string[];
    message: string;
    serviceId: string;
    serviceTypeId: string;
}

export interface ServiceType {
    id: ServiceTypeId;
    name: string;
    title: string;
    description: string;
    imageUrl: string;
    learnMoreUrl: string;
    logo: string;
    services?: Service[];
}

interface base {
    name?: string;
    description?: string;
    imageUrl?: string;
    logo?: string;
    catId?: string;
    learnMoreUrl?: string;
}

export interface Location {
    id: string;
    name: string;
}

export interface ServiceAddress {
    addressId: string;
    serviceAddress: string;
    serviceCityDisplayName?: string;
    serviceUnit: string;
    serviceCity: string;
    serviceState: string;
    serviceZipCode: string;
    wireCenter: string;
}

export interface Product extends base {
    productId: string;
    productCatId?: string;
    typeId?: ProductType;
    default?: string;
    min?: string;
    max?: string;
    required?: boolean;
    additionalInfo?: string
    value: string;
    amount: string;
    percentRate: string;
    totalAmount: number;
    removable: boolean;
    isSelected?: boolean;
    products: Product[];
    serviceTypeId?: string;
    serviceId?: string;
    serviceCatId?: string;
}

export interface Category {
    id: string;
    title: string;
    description: string;
    additionalInfo: string;
    min: number;
    max: number;
    products: Product[];
}

export interface Service extends base {
    amount: string;
    serviceId: string;
    serviceCatId: string;
    serviceTypeName?: string;
    serviceTypeId?: ServiceTypeId;
    products?: Product[];
    categories?: Category[];
    fees?: CartFee[];
    phoneIsUnlimited?: boolean;
    value?: string;
    tvInfo?: AvailableServiceTv;
    removable: boolean;
}

export interface AvailableServiceTv {
    businessType: BusinessType;
    businessPlanType: BusinessPlanType;
}

export interface AvailableOptions {
    serviceTypes: ServiceType[];
}

export interface SelectedOptions {
    cartTotal?: string|number;
    cartMonthlyTotal?: string|number;
    monthlyTotalBeforeFeesAndTaxes?: string;
    cartMonthlyTaxes?: string|number;
    cartNumber?: string;
    services?: Service[];
    discounts?: Discount[];
    oneTimeFees?: CartFee[];
    notificationIds?: CartNotificationIds[];
}

export enum CartNotificationIds {
    NETWORK_ACCESS_CHARGE = 'network-access-charge'
}

export interface ShoppingCartData {
    id: string;
    addressId: string;
    businessType: BusinessType;
    serviceAddress: string; // ID of the service address in the system
    serviceUnit?: string;
    serviceCity?: string;
    serviceCityDisplayName?: string;
    serviceState?: string;
    serviceZipCode?: string;
    regionId?: string;
    wireCenter?: string;
    hasActiveFiber?: boolean;
    activeServiceAddress?: boolean;
    selectedOptions?: SelectedOptions;
    availableOptions?: AvailableOptions;
    errors: CartError[];
    checkoutOnline: boolean;
    checkoutBek: boolean;
    selectedContractId: string;
    customer?: CustomerInfo;
    noRefetch?: boolean;
    queryLogId ?: string;
    token?: string;
    submitted: boolean;
    businessResidence: BusinessResidence;
    isTavern: boolean;
}

export interface AddressResults {
    addressId: string;
    serviceAddress: string;
    unit?: string;
    city: string;
    cityDescription: string;
    zipCode: string;
    regionId: string;
    wireCenter?: string;
    queryLogId?: string
}

export interface ServiceAddressResponse {
    queryLogId: string;
    addresses: AddressResults[];
}
export interface CartDataRequest {
    addressId: string;
    serviceAddress: string;
    serviceCity: string;
    serviceUnit: string;
    selectedContractId: string;
    businessResidence: BusinessResidence;
    services?: SelectedService[];
    customer?: CustomerInfo;
    queryLogId?: string;
    token?: string;
    isTavern: boolean;
}

export interface SelectedServiceProduct {
    serviceTypeId?: string;
    serviceId: string;
    productId?: string;
    productCatId?: string;
    serviceCatId?: string;
    value?: string;
    noRefetch?: boolean;
    path?: string;
}

export interface Validation {
    isMissingBatteryBackup?: boolean;
    isMissingPhoneOption?: boolean;
    isMissingDirectoryOption?: boolean;
    hasInvalidEmailAddresses?: boolean;
    hasInvalidCloudBackupEmail?: boolean;
    hasInvalidTopBoxLeaseOption?: boolean;
    hasInvalidAvastEmail?: boolean;
    hasInvalidVoicemailPlusEmail?: boolean;
    hasInvalidStaticIpOption?: boolean;
    hasInvalidStreamingDevices?: boolean;
}

export interface SelectedService {
    serviceId: string;
    catId: string;
    value?: string;
    products: SelectedProduct[];
}

export interface SelectedProduct {
    productId: string;
    catId: string;
    value?: string;
}

export interface SelectedLocation {
    addressId: string;
    serviceAddress: string;
    serviceCity: string;
    serviceUnit: string;
    regionId: string;
    wireCenter?: string;
    noRefetch?: boolean;
}

export interface ProductServiceItem extends base {
    productId?: string;
    productCatId?: string;
    serviceTypeId?: string;
    serviceId: string;
    serviceCatId: string;
    index: number; // use for image placeholder background image color
    totalAmount?: number;
    value?: string;
    isDiscount?: boolean;
}

export interface ProductTypeFields {
    product: Product;
    serviceTypeId: string;
    serviceId: string;
    serviceCatId: string;
    productIndex: number; // use for image placeholder background image color
    isFullPageShoppingCart: boolean;
}

export interface CustomerInfo {
    firstName: string;
    lastName: string;
    email: string;
    productsAndPromotionsOption: boolean
    landLinePhoneNumber: string;
    mobilePhoneNumber: string;
    mailAddress: string;
    mailUnit: string;
    mailCity: string;
    mailState: string;
    mailZipCode: string;
    installationNotes: string;
    mailSameAsService: boolean;
    followUpId?: string;
}

export interface CustomerWithContract extends CustomerInfo {
    selectedContractId: string;
    noRefetch?: boolean;
}

export interface CityState {
    id: number | string;
    name: string;
    stateAbbreviation: string;
}

export interface Discount {
    name: string;
    description: string;
    amount: string;
}
export interface CartFee  extends Discount{};

export enum SelectedContractOption {
    NONE = '',
    MONTH_TO_MONTH = '1',
    MONTH_12 = '2',
    MONTH_24 = '3',
    BUSINESS_MONTH_36 = '4'
}

export enum CloudBackupType {
    EMAIL = 9,
    DISCOUNT = 10,
    STORAGE_OPTIONS = 11
}

export interface SupportAvailability {
    schedule: AvailabilitySchedule[];
    overrides: AvailabilityScheduleOverride[];
    scheduledCalls: ScheduledCallbacks[];
    maxCallbacksPerHour: number;
    callBackDayRange: number;
}

export interface ScheduledCallbacks {
    followUpRangeStart: string;
    followUpRangeEnd: string;
}

export interface AvailabilitySchedule {
    id: string;
    dayOfWeek: number;
    startTime: string;
    endTime: string;
    type: AvailabilityType;
}

export enum AvailabilityType {
    SUPPORT = 'SUPPORT',
    LOBBY = 'LOBBY'
}

export interface AvailabilityScheduleOverride {
    id: string;
    title: string;
    overrideStartTime: string;
    overrideEndTime: string;
}

export interface CustomerFollowUpResponse {
    followUpId: string;
    customerFirstName: string;
    customerLastName: string;
    customerPhone: string;
    customerEmail: string;
    cancelled: boolean;
    completed: boolean;
    isNewFollowUp: boolean;
}

export enum BusinessResidence {
    Business = 'business',
    Residence = 'residence',
    Both = 'both'
}

export enum BusinessType {
    TAVERN = 'Tavern',
    STANDARD = 'Standard'
}

export enum BusinessPlanType {
    Basic = 'basic',
    Core = 'core',
    None = ''
}

export enum FireOccupancyTier {
    ZeroToFifty = '0-50',
    FiftyOneToOneHundred = '51-100',
    OneHundredOneToOneHundredFifty = '101-150',
    OneHundredFiftyOneToTwoHundred = '151-200',
    TwoHundredOneToThreeHundred = '201-300',
    ThreeHundredOneToFiveHundred = '301-500',
    FiveHundredPlus = '500+',
    Unknown = 'UNKNOWN'
}

export interface Term {
    id: number;
    contractName: string;
    description: string;
    descriptionFormatted: string;
    audience: string;
    showToPublic: boolean;
    catId: string;
}

export const FAKE_TAVERN_CAT_ID = 'FAKE-TAVERN';
export const FAKE_TAVERN_NAME = 'Tavern EPIC TV';
export const FAKE_TAVERN_SERVICE_ID = '30';
